import React, {Component, forwardRef, useEffect, useImperativeHandle, useRef, useState} from 'react';
import { Form} from 'devextreme-react/form';
import dxForm from "devextreme/ui/form";
import LicenceDataSource from '../datasource/LicenceDataSource';
import { useAuthStore } from '../hooks/useAuthStore';
import ReportFormPreparer from '../utils/ReportFormPreparer';
import Guid from "devextreme/core/guid";
import { Toolbar as RealToolbar } from 'devextreme-react/toolbar';



export interface IReportFilterParameters {
    name: string,
    value: any,
    visible: boolean,
    text?: string,
    labelText?: string,
    id?:any,
}

//export interface IReportParameters<T> extends Promise<T> {
export interface IReportParameters {
    reportFilterParameters: Object;
    reportFilterVisibilityParameters: Array<IReportFilterParameters>;
    reportFilterFullParameters: Array<IReportFilterParameters>;
}


export interface IReportFilterExtraParams {
    reportId?: any;
    user?: any;
}

const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms));

const waitForOption = async (obj: object, option: string) => {
    while (obj["option"] && obj["option"](option) == undefined) {
        await sleep(100);
    }
    return;
    return new Promise(resolve => {
        if (obj["option"] && obj["option"](option) != undefined) {
            return obj["option"](option);
        }
    });
}

const ReportFilter = (
    {
        defaultFilter
        ,filterItems
        , runReport
        , reportName
        , reportFilterExtraParams
        , autoBuildReport

        
    }
) => {
    const authStore = useAuthStore();
    const licenceStore = LicenceDataSource.licenceStore(
        {
            url: "/api/main/filter",
            authStore: authStore,
            cacheDuration: 0,
        }
    );

    const [isFilterModify, setIsFilterModify] = useState(false);

    const getFilterItems = () => {
        let filter = null;
        try {
            filter = JSON.parse(defaultFilter["JsonObject"]);
        }
        catch {
        }
        return filter || [];
    }
    const prepareFilterItems = (filterItems) => {
        let res;
        try {
            res = ReportFormPreparer.formPrepare(
                {
                    items: JSON.parse(JSON.stringify(filterItems || []))
                },
                authStore
            )["items"];
        }
        catch {
        }
        return res;
    }

    const replaceDateBoxesToSelectBoxesAndPrepareNoDateBox = (items) => {
        const result = items || [];
        for (let item of result) {
            if (item["editorType"] != "dxDateBox") {
                try {
                    const newObj = prepareFilterItems([item])[0];
                    Object.assign(item, newObj);
                }
                catch {}
                continue;
            }
            item["editorType"] = "dxSelectBox";
            if (!item["editorOptions"]) continue;
            const visible = item["editorOptions"]["visible"];
            const value = item["editorOptions"]["value"];
            const type = item["editorOptions"]["type"];
            item["editorOptions"] = {
                "visible": visible,
                "searchEnabled": false,
                "displayExpr": "description",
                "valueExpr": "methodName",
                "value": value,
                "grouped": true,
                //                "items": Date.getMethodsWithDescription(type),
                "dataSource": {
                    store: {
                        type: 'array',
                        data: Date.getMethodsWithDescription(type),
                        key: 'ID',
                    },
                    group: 'group',
                }
            }
        }
        return result;
    }


    let formRef = useRef(null);
    const paramExists = (name: string, arr: Array<IReportFilterParameters>) => {
        const obj = arr.find(item => item.name?.toLowerCase() == name?.toLowerCase());
        return obj;
    }

//    const getParams = (): IReportParameters => {
    const getParams = async () => {
        let res: Array<IReportFilterParameters> = [];
        res.push({ name: "ReportName", value: reportName, visible: true, text: reportName, labelText: "Отчет",  });
        res.push({ name: "UserName", value: authStore?.user?.UserName, visible: true, text: authStore?.user?.UserName, labelText: "Пользователь", });
        res.push({ name: "UserId", value: authStore?.user?.Id, visible: false, });
        res.push({ name: "LocalDate", value: new Date(), visible: false, });
        for (let param in reportFilterExtraParams) {
            if (paramExists(param, res)) {
                continue;
            }
            res.push({ name: param, value: reportFilterExtraParams[param], visible: false, });
        }
        let mySearchParams = new URLSearchParams(location.search);
        const arr = Array.from(mySearchParams);
        for (const item of arr) {
            if (paramExists(item[0], res)) {
                continue;
            }
            res.push({ name: item[0], value: item[1], visible: false, });
        }
        let form = formRef.current;

        if (form) {
            let instance: dxForm | null = form.instance;
            if (instance) {
                let items = instance.option("items");
                for (let item of items) {
                    let editor = instance.getEditor(item.name);
                    if (editor) {
                        if (editor["NAME"] == "dxSelectBox") {
                            if (editor.option("text") == undefined) {
                                await waitForOption(editor, "text");
                            }
                        }
                    }
                    let editorValue = editor ? editor.option("value") : null;
                    console.log("editor", editor ? editor.option() : editor);
                    let key = null;
                    try {
                        key = item["editorOptions"]["dataSource"]["key"];
                    }
                    catch {}
                    if (item.name) {
                        res.push(
                            {
                                name: item.name,
                                value: editor
                                    ?
                                    (editorValue ? editorValue[key] || editorValue : editorValue)
                                    :
                                    item["editorOptions"]?.value,
                                visible: editor ? editor.option("visible") : false,
                                text: editor ? String(editor.option("text")) : "",
                                labelText: item && item["label"] && item["label"]["text"] ? item["label"]["text"] : item.name,
                            }
                        )
                    }
                }
            }
        }
        res = JSON.parse(JSON.stringify(res));
        const resObj: Object = {};
        for (let item of res) {
            resObj[item.name] = item.value;
        }
        const visibilityParams: Array<IReportFilterParameters> = res
            .filter(item => item.visible != false)
            .map(item => { item["Id"] = new Guid().toString(); return item; });
        return {
            reportFilterParameters: resObj,
            reportFilterVisibilityParameters: visibilityParams,
            reportFilterFullParameters: res,
        };
    }
//    filterItems = filterItems || [];
    const getCurrFilterItems = (isModify) => {
        if (!isModify) {
            return filterItems || [];
        }
        let res = getFilterItems() || [];
        if (isModify) {
            res = replaceDateBoxesToSelectBoxesAndPrepareNoDateBox(res);
        }
//        res = prepareFilterItems(res);
        return res;
    }
    const fillItemsValuesFromParams = async (items) => {
        if (!items) return;
        const params = await getParams();
        for (let item of items) {
            if (!item) continue;
            if (!item["editorOptions"]) continue;
            if (!item["name"]) continue;
            item["editorOptions"]["value"] = params.reportFilterParameters[item["name"]];
        }
    }

    const fillItemsValuesFromItems = async (toItems, fromItems) => {
        if (!toItems) return;
        if (!fromItems) return;
        fromItems = fromItems || [];        
        for (let item of toItems) {
            if (!item) continue;
            if (!item["editorOptions"]) continue;
            if (!item["name"]) continue;
            try {
                item["editorOptions"]["value"] = (fromItems || []).filter(it => it.name == item.name)[0].editorOptions?.value;
            }
            catch {}
        }
    }

    const setFilterItemsFromParams = async () => {
        await fillItemsValuesFromParams(filterItems);
    }
    const saveDefaultFilter = async () => {
        if (!defaultFilter) return;
        const params = await getParams();
        let defaultFilterJsonObject;
        try {
            defaultFilterJsonObject = JSON.parse(defaultFilter["JsonObject"]);
        }
        catch {
            return;
        }
        if (!defaultFilterJsonObject) return;
        await fillItemsValuesFromParams(defaultFilterJsonObject);
        const preparedFilter = prepareFilterItems(defaultFilterJsonObject);
        fillItemsValuesFromItems(filterItems, preparedFilter);
        defaultFilter["JsonObject"] = JSON.stringify(defaultFilterJsonObject, null, "  ");
        await licenceStore.update(
            defaultFilter["Id"],
            {
                JsonObject: defaultFilter["JsonObject"],
            }
        );
        await setIsFilterModify(false);
    }

    useEffect(
        () => {
            if (autoBuildReport) {
                setTimeout(async () => await runReport(await getParams()), 0);
            }
        }
        ,
        []
    );

    const toolbarItemsNormal = () => {
        return [
            {
                widget: 'dxButton',
                location: 'before',
                visible: true,
                options: {
                    text: "Сформировать",
                    hint: "Сформировать",
                    onClick: async () => await runReport(await getParams()),
                },
            },
            {
                widget: 'dxButton',
                location: 'after',
                visible: true,
                options: {
                    text: "Ф",
                    hint: "Изменить шаблон фильтра",
                    onClick: async () => {
                        await setFilterItemsFromParams();//предварительно сохраняем текущие значения, чтобы при отмене вернуться к ним
                        await setIsFilterModify(true);
                    }
                },
            },
        ];
    }
    const toolbarItemsModifyFilter = () => {
        return [
            {
                widget: 'dxButton',
                location: 'before',
                visible: true,
                options: {
                    text: "Сохранить фильтр",
                    hint: "Сохранить шаблон фильтра",
                    onClick: async () => saveDefaultFilter()
                },
            },
            {
                widget: 'dxButton',
                location: 'after',
                visible: true,
                options: {
                    text: "X",
                    hint: "Не сохранять шаблон фильтра",
                    onClick: async () => setIsFilterModify(false)
                },
            },
        ];
    }


    return (
        <div>
            <h2
                className="report-filter-title"
            >
                {reportName}
            </h2>
            <hr/>
            <h3
                className="report-filter-parameters"
            >
                Параметры
            </h3>
            <Form
                ref={formRef}
                items={getCurrFilterItems(isFilterModify)}
                labelMode="static"
            />
            <RealToolbar
                items={toolbarItemsNormal()}
                visible={!isFilterModify}
            />
            <RealToolbar
                items={toolbarItemsModifyFilter()}
                visible={isFilterModify}
            />

            {
                false && <img hidden={true} src="" onError={async (e) => await runReport(await getParams())} />
            }
        </div>
    );
}


export default React.memo(ReportFilter);

